module.exports = __webpack_public_path__ + "img/user-fun.9033e123.png";